import React from 'react'
import { Link } from 'react-router-dom'
import logo from './rocket.svg'
import './top-nav.css'

import { IS_EMBEDDED } from '../../embedded'
import { FormButton } from '@myxplor/forms'

const signout = () => {
  return fetch(`${process.env.REACT_APP_AUTH_HOST}/api/v1/logout`, {
    method: 'POST',
    credentials: 'include',
  }).finally(() => {
    window.location = '/'
  })
}

const TopNav = () => (
  <div className="topNav">
      <Link to="/">
        <img src={logo} className="topNav--logo" alt="" />
      </Link>
      <div>
        {!IS_EMBEDDED &&
          <FormButton onClick={signout}>
            Sign Out
          </FormButton>}
      </div>
  </div>
)

export default TopNav



// WEBPACK FOOTER //
// ./src/layout/top-nav/index.jsx